export default "__VITE_ASSET__708341eb__"